import { create } from 'zustand';
import type { NotificationRecord } from '@nexus/store';

/** In-app pop-ups for fresh reminders (the bell keeps the full list). */
interface ToastState {
  toasts: NotificationRecord[];
  push: (n: NotificationRecord) => void;
  dismiss: (id: string) => void;
}

const MAX = 4;
const VISIBLE_MS = 15_000;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (n) => {
    set((s) => ({ toasts: [n, ...s.toasts.filter((t) => t.id !== n.id)].slice(0, MAX) }));
    setTimeout(() => get().dismiss(n.id), VISIBLE_MS);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
